import { rlPoint, rlLineGrid } from "@/rlMxModules/index";
import { getRlLayer } from "@/mixins/LiteModuleDb.js";
import mxcad from "mxcad";
const { MxCADSelectionSet, MxCADResbuf, MxCADUiPrPoint } = mxcad;

import { get_entity_by_id } from "@/rlMxModules/operate/index";
import { Message } from "element-ui";
import store from "@/store";
import { resetRlModules, getRlModules } from "@/mixins/LiteModuleDb.js";

import { revokeRollback } from "@/rlMxModules/operate/revokeRollback.js";

export const addEntityToDatabase = async (addEntity) => {
  //将新增数据更新至indexdb
  if (
    addEntity.classTypeName != "rlText" &&
    addEntity.classTypeName != "rlLine" &&
    addEntity.classTypeName != "rlEntity" &&
    addEntity.classTypeName != "rlCircle"
  ) {
    addEntity.StdFlrGuid = store.state.globalData.rl_stdFlr_id;

    await resetRlModules(
      addEntity.classTypeName,
      store.state.globalData.rl_stdFlr_id,
      addEntity.Guid,
      addEntity.getDataBase()
    );
  }
};

export const addRevokeToDatabase = async (addEntity) => {
  //缓存撤销回退操作
  if (
    !store.state.globalData.isReDo &&
    addEntity.classTypeName != "rlText" &&
    addEntity.classTypeName != "rlLine" &&
    addEntity.classTypeName != "rlEntity" &&
    addEntity.classTypeName != "rlCircle"
  ) {
    await revokeRollback(addEntity, store.state.globalData.drawStep, "add");
  }
};

export const addEntityToDrawing = async (addEntity, bInit = false) => {
  let isExist = false;
  if (addEntity.m_groupName == "rlPointGroup") {
    isExist = await addPointEntityToDrawing(addEntity, bInit, false); //初始化不需要计算
  } else if (addEntity.m_groupName == "rlLineGridGroup") {
    addGridEntityToDrawing(addEntity, bInit);
    // return;
  } else if (addEntity.m_groupName == "rlTextGroup") {
    rlAppObj.rlMxDrawObject.addMxEntity(addEntity);
    //rlAppObj.rlMxDrawObject.addMxEntity(addEntity.m_mxText)
    let rlGroup = rlAppObj.rlMxDatabase.addGroup(addEntity.m_groupName);
    rlGroup.append(addEntity);
    //rlGroup.append(addEntity.m_mxText)
  } else {
    rlAppObj.rlMxDrawObject.addMxEntity(addEntity);
    let rlGroup = rlAppObj.rlMxDatabase.addGroup(addEntity.m_groupName);
    rlGroup.append(addEntity);

    if (addEntity.m_groupName === "rlLineAxisGroup") {
      addEntity.calAxisNameData();
      addEntity.setNeedUpdateDisplay(true);
    }
  }
  //判断节点是否已经存在，如果已经存在，不需要添加画布
  if (isExist) return isExist;

  if (!bInit) {
    //维护构件的No_字段---用于后端数据匹配
    if (addEntity.ModelType) {
      addEntity.No_ = await store.dispatch(
        "globalData/getStructNum",
        addEntity.classTypeName
      );
    }
    //将新增数据更新至indexdb
    await addEntityToDatabase(addEntity);
    await addRevokeToDatabase(addEntity);
  }

  if (addEntity.m_groupName === "rlLineAxisGroup") {
    if (!addEntity.m_stJoint.m_AxisIds.includes(addEntity.objectId())) {
      addEntity.m_stJoint.m_AxisIds.push(addEntity.objectId());
    }

    if (!addEntity.m_edJoint.m_AxisIds.includes(addEntity.objectId())) {
      addEntity.m_edJoint.m_AxisIds.push(addEntity.objectId());
    }
  }
  //添加构件的文字
  if (addEntity.componentType) {
    addEntity.createText();
  }
  return false;
};

//绘制节点到画布上
export const addPointEntityToDrawing = async (
  addEntity,
  bInit,
  isOnGrid,
  pushDataBase = false
) => {
  //判断点是否已经存在，如果已经存在，不需要添加画布
  if (!bInit) {
    let isExist = await JointIsExist(addEntity);
    if (isExist) {
      return isExist;
    }
    //如果不知道是否节点在网格上，则判断点是否在网格上，如果在，切分网格
    if (!isOnGrid) {
      let onGrids = await JointIsOnGrid(addEntity);
      if (onGrids && onGrids.length) {
        onGrids.forEach((item) => {
          if (item) {
            //切分网格
            jointCutGrid(addEntity, item);
          }
        });
      }
    }
  }

  rlAppObj.rlMxDrawObject.addMxEntity(addEntity);
  addEntity.mcDbPointId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbPoint);
  let rlGroup = rlAppObj.rlMxDatabase.addGroup(addEntity.m_groupName);
  rlGroup.append(addEntity);

  if (!bInit && pushDataBase) {
    await addEntityToDatabase(addEntity);
    await addRevokeToDatabase(addEntity);
  }
  return false;
};

//添加网格实体到画布
export const addGridEntityToDrawing = async (
  addEntity,
  bInit,
  isInsertGrid,
  pushDataBase = false
) => {
  //如果没判断网格相交，则计算网格之间是否有交点
  if (!bInit && !isInsertGrid) {
    gridLineInsertWith(addEntity);
  } else {
    addEntity.points = [
      new THREE.Vector3(...addEntity.m_stJoint.m_pt),
      new THREE.Vector3(...addEntity.m_edJoint.m_pt),
    ];

    rlAppObj.rlMxDrawObject.addMxEntity(addEntity);
    addEntity.mcDbGridId = rlAppObj.mxcadObject.drawEntity(addEntity.mcDbGrid);
    let rlGroup = rlAppObj.rlMxDatabase.addGroup(addEntity.m_groupName);
    rlGroup.append(addEntity);
  }
  if (!bInit && pushDataBase) {
    await addEntityToDatabase(addEntity);
    // await addRevokeToDatabase(addEntity);
  }
};

let removeGrids = []; // 用于存储需要删除的网格

//判断网格是否与其他网格相交，若相交，增加节点
export const gridLineInsertWith = (objCurrGird) => {
  if (objCurrGird) {
    let pt1 = objCurrGird.points[0];
    let pt2 = objCurrGird.points[1];

    let insertPtArray = new Array();
    let rlGroup = rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.getAll(); //获取当前图纸中的网格数据
    if (rlGroup) {
      // 从 rlGroup 中删除需要删除的网格
      rlGroup = rlGroup.filter((grid) => !removeGrids.includes(grid));

      rlGroup.forEach((objTmp) => {
        if (objTmp) {
          let pt1Tmp = objTmp.points[0];
          let pt2Tmp = objTmp.points[1];

          const insertRes = lineInsection(pt1, pt2, pt1Tmp, pt2Tmp);
          if (insertRes.isIntersected) {
            //添加一个节点
            let rlPointObj = new rlPoint();
            rlPointObj.setPoints([
              insertRes.intersectionPoint["x"],
              insertRes.intersectionPoint["y"],
              insertRes.intersectionPoint["z"],
            ]);
            addPointEntityToDrawing(rlPointObj, false, true, true);
            jointCutGrid(rlPointObj, objTmp);
            insertPtArray.push(rlPointObj);
            removeGrids.push(objTmp); // 将需要删除的网格添加到 removeGrids 数组中
          }
        }
      });
    }
    if (insertPtArray && insertPtArray.length) {
      jointArrayCutGrid(insertPtArray, objCurrGird);
    } else {
      addGridEntityToDrawing(objCurrGird, false, true, true);
    }
  }
};

//节点将网格切分
async function jointCutGrid(joint, grid) {
  if (joint && grid) {
    let newGrid = grid.myClone();
    newGrid.m_stJoint = grid.m_stJoint;
    newGrid.m_edJoint = joint;
    newGrid.m_Axis = grid.m_Axis;
    await addGridEntityToDrawing(newGrid, false, true, true);
    joint.m_gridIds.push(newGrid.objectId());

    if (grid.m_wallId) {
      let objtmpWall = rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
      if (objtmpWall) {
        let newWallObj = await objtmpWall.myClone();
        newWallObj.m_gridData = newGrid;
        await addEntityToDrawing(newWallObj, false);
      }
    }

    if (grid.m_beamId) {
      let objtmpBeam = rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
      if (objtmpBeam) {
        let newBeamObj = objtmpBeam.myClone();
        newBeamObj.m_gridData = newGrid;

        await addEntityToDrawing(newBeamObj, false);
      }
    }

    let newGrid1 = grid.myClone();
    newGrid1.m_stJoint = joint;
    newGrid1.m_edJoint = grid.m_edJoint;
    newGrid1.StdFlrGuid = store.state.globalData.rl_stdFlr_id;
    newGrid1.m_Axis = grid.m_Axis;
    await addGridEntityToDrawing(newGrid1, false, true, true);
    joint.m_gridIds.push(newGrid1.objectId());

    if (grid.m_wallId) {
      let objtmpWall = rlAppObj.rlMxDrawObject.getMxEntity(grid.m_wallId);
      if (objtmpWall) {
        let newWallObj = await objtmpWall.myClone();
        newWallObj.m_gridData = newGrid1;
        await addEntityToDrawing(newWallObj, false);
      }
    }

    if (grid.m_beamId) {
      let objtmpBeam = rlAppObj.rlMxDrawObject.getMxEntity(grid.m_beamId);
      if (objtmpBeam) {
        let newBeamObj = objtmpBeam.myClone();
        newBeamObj.m_gridData = newGrid1;

        await addEntityToDrawing(newBeamObj, false);
      }
    }

    grid.erase();
  }
}

function jointArrayCutGrid(jointArray, grid) {
  //对网格上的节点排序，依次绘制出分段网格
  if (jointArray && jointArray.length) {
    jointArray.unshift(grid.m_stJoint);
    jointArray.push(grid.m_edJoint);
    let st = grid.m_stJoint.m_pt;
    let ptStart = new THREE.Vector3(st[0], st[1], st[3]);
    jointArray.sort(
      (a, b) =>
        new THREE.Vector3(a.m_pt[0], a.m_pt[1], a.m_pt[3]).distanceTo(ptStart) -
        new THREE.Vector3(b.m_pt[0], b.m_pt[1], b.m_pt[3]).distanceTo(ptStart)
    );
    for (let i = 0; i < jointArray.length - 1; i++) {
      let newGrid = new rlLineGrid();
      newGrid.m_stJoint = jointArray[i];
      newGrid.m_edJoint = jointArray[i + 1];
      newGrid.m_Axis = grid.m_Axis;

      addGridEntityToDrawing(newGrid, false, true, true);
    }
  }
}

function lineInsection(line1_pt1, line1_pt2, line2_pt1, line2_pt2) {
  const EPRES = 1e-6; // 用于比较浮点数的阈值

  if (
    Math.abs(line1_pt1.z - line2_pt1.z) > EPRES ||
    Math.abs(line1_pt2.z - line2_pt2.z) > EPRES
  ) {
    return { isIntersected: false };
  }

  // 求直线解析方程：a * x + b * y + c = 0 (a >= 0)
  let a = line1_pt2.y - line1_pt1.y;
  let b = line1_pt1.x - line1_pt2.x;
  let c = line1_pt2.x * line1_pt1.y - line1_pt2.y * line1_pt1.x;

  if (a < -EPRES) {
    a = -a;
    b = -b;
    c = -c;
  }

  let aOther = line2_pt2.y - line2_pt1.y;
  let bOther = line2_pt1.x - line2_pt2.x;
  let cOther = line2_pt2.x * line2_pt1.y - line2_pt2.y * line2_pt1.x;

  if (aOther < -EPRES) {
    aOther = -aOther;
    bOther = -bOther;
    cOther = -cOther;
  }

  let dTmp = a * bOther - aOther * b;

  if (Math.abs(dTmp) < EPRES) {
    // 不相交
    return { isIntersected: false };
  }
  let InsectPt = {
    x: (cOther * b - c * bOther) / dTmp,
    y: (aOther * c - a * cOther) / dTmp,
    z: line1_pt1.z,
  };
  //判断点是否在线段上
  if (
    ptOnLine(line1_pt1, line1_pt2, InsectPt) == 1 &&
    ptOnLine(line2_pt1, line2_pt2, InsectPt) == 1
  )
    return { isIntersected: true, intersectionPoint: InsectPt };
  else return { isIntersected: false };
}

export function ptOnLine(line1_pt1, line1_pt2, pt) {
  //点在线段端点上
  if (Math.abs(line1_pt1.x - pt.x) < 50 && Math.abs(line1_pt1.y - pt.y) < 50)
    return 2; //和传入的起点相等时
  if (Math.abs(line1_pt2.x - pt.x) < 50 && Math.abs(line1_pt2.y - pt.y) < 50)
    return 3; //和传入的终点相等时

  //判断点是否在线段上

  const point = new THREE.Vector3(pt.x, pt.y, pt.z);
  if (
    Math.abs(
      point.distanceTo(line1_pt1) +
        point.distanceTo(line1_pt2) -
        line1_pt1.distanceTo(line1_pt2)
    ) < 1
  ) {
    //交点到两端的距离之和=线段长度即可判断点在线上
    return 1;
  } else {
    return -1;
  }
}
//新增节点是否已经存在
export const JointIsExist = (obj) => {
  let point = obj.m_pt;
  let rlGroup = rlAppObj.rlMxDatabase.getGroup("rlPointGroup")?.getAll(); //获取当前图纸中的节点数据
  if (rlGroup) {
    for (let i = 0; i < rlGroup.length; i++) {
      let ptTmp = rlGroup[i].m_pt;
      if (
        Math.abs(ptTmp[0] - point[0]) < 100 &&
        Math.abs(ptTmp[1] - point[1]) < 100
      ) {
        return rlGroup[i];
      }
    }
    return false;
  }
  return false;
};

//新增节点是否在网格上
export const JointIsOnGrid = (point) => {
  let pointTmp = point instanceof Array ? point : point.m_pt;
  let pt = new THREE.Vector3(pointTmp[0], pointTmp[1], pointTmp[2]);
  let rlGroup = rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.getAll(); //获取当前图纸中的网格数据
  let onGrids = new Array();
  if (rlGroup) {
    rlGroup = rlGroup.filter((grid) => !removeGrids.includes(grid));
    for (let i = 0; i < rlGroup.length; i++) {
      let pt1Tmp = rlGroup[i].points[0];
      let pt2Tmp = rlGroup[i].points[1];
      let res = ptOnLine(pt1Tmp, pt2Tmp, pt);

      if (res == 1) {
        const lineOrigin = new THREE.Line3(
          new THREE.Vector3(pt1Tmp.x, pt1Tmp.y, pt1Tmp.z),
          new THREE.Vector3(pt2Tmp.x, pt2Tmp.y, pt2Tmp.z)
        );
        const ptTmp = new THREE.Vector3(pt.x, pt.y, pt.z);
        let InsectPt = null;
        InsectPt = lineOrigin.closestPointToPoint(ptTmp);
        point.m_pt = [InsectPt.x, InsectPt.y, InsectPt.z];
        onGrids.push(rlGroup[i]);
        removeGrids.push(rlGroup[i]);
      }
    }
    return onGrids;
  }
};

let mxSelect = null;
let clickHandlerRef = null;
let messageObj = null;
let filterIds = [];
// 处理选中的对象ID
const processIds = async (isDele, callback) => {
  const ids = mxSelect.getIds().reduce((acc, obj) => {
    // 检查新数组中是否已经存在相同 id 的对象
    const existingObj = filterIds.find((item) => item.id == obj.id);
    if (!existingObj) {
      // 如果不存在相同 id 的对象，则将当前对象推送到新数组中
      acc.push(obj);
      filterIds.push(obj); // 将当前对象推送到 filterIds 数组中
    }
    return acc;
  }, []);
  if (ids && ids.length > 0) {
    ids.forEach((e) => {
      let mcObj = e.getMcDbEntity(); // 获取数据库实体
      let selObj =
        mcObj &&
        get_entity_by_id(Number(mcObj.getxDataString("mcObjectId").val)); // 获取选中的对象
      if (selObj && selObj.classTypeName === "rlGrid") {
        selObj.dLineWidth = isDele ? 0 : 5; // 根据是否删除设置线宽
        selObj.setNeedUpdateDisplay(true); // 设置需要更新显示
      }
    });
  }

  if (callback) {
    await callback(ids, isDele);
  }
};

// 点击处理函数
const clickHandler = (isDele, callback) => {
  return () => {
    processIds(isDele, callback); // 处理选中的对象ID
  };
};

// 初始化选择
export const initSelect = (bol, callback) => {
  clickHandlerRef = clickHandler(false, callback); // 设置点击处理函数
  document.addEventListener("click", clickHandlerRef); // 添加点击事件监听器
};

// 移除选择
export const removeSelect = () => {
  processIds(true); // 处理选中的对象ID
  filterIds = [];
  if (clickHandlerRef) {
    document.removeEventListener("click", clickHandlerRef); // 移除点击事件监听器
  }
};

// 通过鼠标选择多个对象
export const userSelect = (
  callback, // 回调函数
  str = "框选需要的对象",
  filter = null
) => {
  messageObj = Message({
    message: "请框选需要的对象",
    type: "info",
  });
  if (clickHandlerRef) {
    removeSelect(); // 移除已有的事件监听器
  }
  mxSelect = null;
  return new Promise((reslove, reject) => {
    // 通过鼠标选择多个对象
    mxSelect = new MxCADSelectionSet();
    mxSelect.isSelectHighlight = false;
    mxSelect
      .userSelect(str, filter, initSelect(false, callback))
      .then(async (is) => {
        let ids = mxSelect.getIds();
        await ids.forEach((e) => {
          let mcObj = e.getMcDbEntity(); // 获取数据库实体
          let selObj =
            mcObj &&
            get_entity_by_id(Number(mcObj.getxDataString("mcObjectId").val)); // 获取选中的对象
          if (selObj && selObj.classTypeName === "rlGrid") {
            selObj.dLineWidth = 0; // 根据是否删除设置线宽
            selObj.setNeedUpdateDisplay(true); // 设置需要更新显示
          }
        });
        removeSelect();
        messageObj.close();
        rlAppObj.rlMxDrawObject.clearMxCurrentSelect();
        is ? reslove(ids) : reject("非主动状态结束");
      });
  });
};

// 选取实体
export const select_entiy_get = () => {
  return new Promise(async (resolve, reject) => {
    const id = await rlAppObj._rlMx.MxFun.selectEnt("提示信息");
    if (!id) return;
    let entiyData = rlAppObj.rlMxDrawObject.getMxEntity(id);
    resolve(entiyData);
  });
};

export const updateModelColor = async () => {
  try {
    //获取构件的图层颜色
    let rlLayer = await getRlLayer();

    let beamColor = rlLayer.filter((item) => item.Type == "rlBeamSeg");
    let wallColor = rlLayer.filter((item) => item.Type == "rlWallSeg");
    let colColor = rlLayer.filter((item) => item.Type == "rlColSeg");
    let slabColor = rlLayer.filter((item) => item.Type == "rlSlabSeg");
    let ringBeamColor = rlLayer.filter((item) => item.Type == "rlRingBeamSeg");
    let subBeamColor = rlLayer.filter((item) => item.Type == "rlSubBeam");
    if (beamColor && wallColor && colColor && slabColor) {
      beamColor = beamColor[0].Color;
      wallColor = wallColor[0].Color;
      colColor = colColor[0].Color;
      slabColor = slabColor[0].Color;
      ringBeamColor = ringBeamColor[0].Color;
      subBeamColor = subBeamColor[0].Color;

      //获取所有模型对象
      let allMxEntity = rlAppObj.rlMxDrawObject.getAllMxEntity();
      if (!allMxEntity || allMxEntity.length < 1) {
        return;
      }

      // 绘制步数
      // store.commit("globalData/addRawStep");

      for (let i = 0; i < allMxEntity.length; i++) {
        const objTmp = allMxEntity[i];

        if (objTmp.classTypeName == "rlBeamSeg") {
          if (objTmp.Color != beamColor) {
            objTmp.Color = beamColor;
            objTmp.setNeedUpdateDisplay();
          }
        } else if (objTmp.classTypeName == "rlWallSeg") {
          if (objTmp.Color != wallColor) {
            objTmp.Color = wallColor;
            objTmp.setNeedUpdateDisplay();
          }
        } else if (objTmp.classTypeName == "rlColSeg") {
          if (objTmp.Color != colColor) {
            objTmp.Color = colColor;
            objTmp.setNeedUpdateDisplay();
          }
        } else if (objTmp.classTypeName == "rlSlab") {
          if (objTmp.Color != slabColor) {
            objTmp.Color = slabColor;
            objTmp.setNeedUpdateDisplay();
          }
        } else if (objTmp.classTypeName == "rlRingBeamSeg") {
          if (objTmp.Color != ringBeamColor) {
            objTmp.Color = ringBeamColor;
            objTmp.setNeedUpdateDisplay();
          }
        } else if (objTmp.classTypeName == "rlSubBeam") {
          if (objTmp.Color != subBeamColor) {
            objTmp.Color = subBeamColor;
            objTmp.setNeedUpdateDisplay();
          }
        }
      }
      //更新构件颜色
      rlAppObj.rlMxDrawObject.updateDisplay();
    }
  } catch (error) {}
};

//对轴线归类排序
export const sortAxisData = async (rlAxisroup) => {
  //找到平行线--分组:key==斜率，value==轴线数组
  let slopeGroup = {};
  rlAxisroup.forEach((axis) => {
    let pt1 = axis.m_stJoint.m_pt;
    let pt2 = axis.m_edJoint.m_pt;
    let slope =
      Math.abs(pt1[0] - pt2[0]) < 0.1
        ? 9999
        : (pt1[1] - pt2[1]) / (pt1[0] - pt2[0]);
    // if (slope < 0) slope = -slope;

    if (slopeGroup[slope]) {
      slopeGroup[slope].push(axis);
    } else {
      let arrayTmp = [];
      arrayTmp.push(axis);
      slopeGroup[slope] = arrayTmp;
    }
  });

  let resAxisData = {};
  //按照分组对轴线排序
  Object.keys(slopeGroup).forEach(async (key) => {
    let value = slopeGroup[key];
    if (value && value.length > 0) {
      //对轴线排序
      let sortAxisData = {};
      //以第一条为基准，记录其他轴线到此轴线的间距（有方向）
      const lineOrigin = new THREE.Line3(
        new THREE.Vector3(...value[0].m_stJoint.m_pt),
        new THREE.Vector3(...value[0].m_edJoint.m_pt)
      );
      value.forEach(async (itemTmp) => {
        const ptTmp = new THREE.Vector3(...itemTmp.m_stJoint.m_pt);
        let InsectPt = null;
        //
        InsectPt = lineOrigin.closestPointToPoint(ptTmp);
        if (InsectPt) {
          let distance = ptTmp.distanceTo(InsectPt);
          let perLine = new THREE.Line3(InsectPt, ptTmp);
          let vecDir = new THREE.Vector3();
          perLine.delta(vecDir);
          if (vecDir.x < 0) {
            distance = -distance;
          } else if (vecDir.y < 0) {
            distance = -distance;
          }
          sortAxisData[distance] = itemTmp;
        }
      });
      resAxisData[key] = sortAxisData;
    }
  });
  return resAxisData;
};

//计算两条轴线的间距
export const getDistanceBetweenTwoAxis = (objAxis1, objAxis2) => {
  //判断两条轴线是否平行，若不平行，返回-1
  let slope1 =
    Math.abs(objAxis1.m_stJoint.m_pt[0] - objAxis1.m_edJoint.m_pt[0]) < 0.1
      ? 9999
      : (objAxis1.m_stJoint.m_pt[1] - objAxis1.m_edJoint.m_pt[1]) /
        (objAxis1.m_stJoint.m_pt[0] - objAxis1.m_edJoint.m_pt[0]);

  let slope2 =
    Math.abs(objAxis2.m_stJoint.m_pt[0] - objAxis2.m_edJoint.m_pt[0]) < 0.1
      ? 9999
      : (objAxis2.m_stJoint.m_pt[1] - objAxis2.m_edJoint.m_pt[1]) /
        (objAxis2.m_stJoint.m_pt[0] - objAxis2.m_edJoint.m_pt[0]);

  if (slope1 !== slope2) return -1;
  else {
    const lineOrigin = new THREE.Line3(
      new THREE.Vector3(...objAxis1.m_stJoint.m_pt),
      new THREE.Vector3(...objAxis1.m_edJoint.m_pt)
    );
    const ptTmp = new THREE.Vector3(...objAxis2.m_edJoint.m_pt);
    let InsectPt = null;
    InsectPt = lineOrigin.closestPointToPoint(ptTmp);
    if (InsectPt) {
      return ptTmp.distanceTo(InsectPt);
    }
  }
};
